'use client';

import { IsCampaignPageTypeContextProvider } from './campaign-type';

import type { PropsWithChildren } from 'react';

export default function CampaignProviders({
  showCampaigns = false,
  children,
}: PropsWithChildren<{
  showCampaigns: boolean;
}>) {
  return (
    <IsCampaignPageTypeContextProvider value={showCampaigns}>
      {children}
    </IsCampaignPageTypeContextProvider>
  );
}
